import { createKiddoAxios } from "./httpClient";

let rewardApiPromise;
const getRewardApi = async () => {
  if (!rewardApiPromise) {
    rewardApiPromise = createKiddoAxios({ timeout: 10000 });
  }
  return rewardApiPromise;
};

/**
 * Fetch reward summary and available rewards for a student
 * @param {number|string} studentId
 * @returns {Promise<object>}
 */
export const getRewardsByStudentId = async (studentId) => {
  if (!studentId) {
    throw new Error("Student ID is required to fetch rewards");
  }

  const api = await getRewardApi();
  const response = await api.get(`/Read/GetRewards`, { params: { studentId } });

  return response.data;
};

/**
 * Redeem a reward for the current student
 * @param {{ studentId:number|string, rewardId:number|string, quantity?:number, requestedBy:number|string }} payload
 * @returns {Promise<object>}
 */
export const redeemReward = async (payload) => {
  if (!payload?.studentId || !payload?.rewardId) {
    throw new Error("studentId and rewardId are required to redeem a reward");
  }

  const requestBody = {
    quantity: 1,
    requestedBy: payload.studentId,
    ...payload,
  };

  const api = await getRewardApi();
  const response = await api.post("/Insert/RedeemReward", requestBody);
  return response.data;
};
